<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Add New Document for Release
							</div>
				
							<div class="page_main">
								<div class="btn_el">
									<div class="tips">
										Please complete the document type, document number, revision, and document name for the new document.
									</div>
								</div>
				
								<div class="form-card">
									<el-form
										ref="formRef"
										:model="form"
										:rules="rules"
										label-position="top"
										class="doc-form"
									>
				
										<el-form-item label="Document Type" prop="leixing_id">
											<el-select
												v-model="form.leixing_id"
												placeholder="Please select a document type"
												class="full-width"
												clearable
											>
												<el-option
													v-for="value in resourcesLeixingList"
													:key="value.id"
													:label="value.title"
													:value="value.id"
												/>
											</el-select>
										</el-form-item>
				
										<el-form-item label="Document Number" prop="ref">
											<el-input
												v-model="form.ref"
												placeholder="Please enter the document number"
											/>
										</el-form-item>
				
										<el-form-item label="Revision" prop="vnumber">
											<el-input
												v-model="form.vnumber"
												placeholder="Please enter the revision"
											/>
										</el-form-item>
				
										<el-form-item label="Document Name" prop="vname">
											<el-input
												v-model="form.vname"
												placeholder="Please enter the document name"
											/>
										</el-form-item>
				
										<div class="btn_el">
											<div class="tips">
												Please note that the approvals required for formal review depend on the document type, company, and department of each document.
											</div>
										</div>
				
										<!-- <el-form-item label="Company" prop="company_id">
											<div class="dept-row">
												<el-select
													v-model="form.company_id"
													placeholder="Please select a company"
													class="full-width"
													@change="getDepartment(form.company_id)"
												>
													<el-option
														v-for="value in companyList"
														:key="value.id"
														:label="value.company_name"
														:value="value.id"
													/>
												</el-select>
											</div>
										</el-form-item> -->
				
										<el-form-item label="Department" prop="departments_id">
											<div class="dept-row">
												<el-select
													v-model="form.departments_id"
													placeholder="Please select a department"
													class="full-width"
												>
													<el-option
														v-for="value in departmentsList"
														:key="value.id"
														:label="value.departments_name"
														:value="value.id"
													/>
												</el-select>
											</div>
										</el-form-item>
				
										<div class="divider" />
				
										<div class="btn_el">
											<div class="tips">
												Please describe the reason for releasing this document and upload the document file.
											</div>
										</div>
				
										<el-form-item
											label="Change Description"
											prop="vdesc"
										>
											<el-input
												v-model="form.vdesc"
												type="textarea"
												:rows="8"
												placeholder="Please describe the changes made to this document."
											/>
										</el-form-item>
				
										<el-form-item
											v-if="vid && nowFile"
											label="Current Document File"
										>
											<div
												class="file-name"
												@click="viewFile(nowFile.url)"
											>
												{{ nowFile.name }}
											</div>
										</el-form-item>
				
										<!-- Document Upload -->
										<div class="upload-doc-wrapper">
											<div class="upload-title">
												{{ vid ? 'Replace Document File' : 'Document File to Upload' }}
												<span class="upload-limit">
													(Maximum 10 MB)
												</span>
											</div>
				
											<div class="upload-box">
												<el-upload
													ref="uploadBox"
													class="doc-upload"
													action="/api/resourcesUploads"
													name="files"
													:headers="{ token: userToken }"
													:show-file-list="false"
													:before-upload="beforeAvatarUpload"
													:on-success="handleAvatarSuccess"
													:limit="1"
													:with-credentials="true"
												>
													<el-button
														size="medium"
														class="select-btn"
													>
														Select File
													</el-button>
												</el-upload>
				
												<div
													class="file-name"
													:class="{ placeholder: !fileName }"
												>
													{{ fileName || "No file selected" }}
												</div>
											</div>
										</div>
				
									</el-form>
				
									<div class="btn_box">
										<van-button
											class="btn_el"
											type="default"
											round
											@click="handleCancel"
										>
											Cancel
										</van-button>
				
										<van-button
											class="btn_el"
											round
											color="linear-gradient(to right, #7BC1FF, #4886FF)"
											@click="handleSubmit"
										>
											Save
										</van-button>
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { resourcesLeixingList } from '@/api/docManage/configureDocControl/index';
// import { companyList } from '@/api/system/company';
import { departmentsList } from '@/api/system/department';
import { resourcesAdd, resourcesVersionDetail } from '@/api/docManage/changeRequest/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			fileName: '',
			selectedFile: null,
			nowFile: null,
			form: {
				leixing_id: '',
				ref: '',
				vnumber: '',
				vname: '',
				// company_id: '',
				departments_id: '',
				vdesc: ''
			},
			rules: {
				leixing_id: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
				ref: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				vnumber: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				vname: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				// company_id: [
				// 	{ required: true, message: 'Please select', trigger: 'change' },
				// ],
				departments_id: [
					{ required: true, message: 'Please select', trigger: 'change' },
				],
				vdesc: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
			},
			// companyList: [],
			departmentsList: [],
			resourcesLeixingList: [],
			userToken: localStorage.getItem('userToken'),
			vid: null
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		if(that.$route.query.vid) { that.vid = that.$route.query.vid; }
		if(that.vid) {
			//编辑
			//请求文件类型
			resourcesLeixingList({ page: 1, page_size: 9999, keyword: '' }).then(res => {
				if(res.code == 200) {
					//请求公司列表
					// companyList({ page: 1, page_size: 9999, status: 1, company_name: '', company_userid: '', manage_userid: '' }).then(res2 => {
					// 	if(res2.code == 200) {
							that.resourcesLeixingList = res.data.data;
							// that.companyList = res2.data.data;
							//请求版本详情
							resourcesVersionDetail({ vid: that.vid }).then(res3 => {
								if(res3.code == 200) {
									that.form = {
										old_vid: res3.data.old_vid,
										leixing_id: res3.data.leixing_id,
										ref: res3.data.ref,
										vnumber: res3.data.vnumber,
										vname: res3.data.vname,
										// company_id: res3.data.company_id,
										vdesc: res3.data.vdesc,
										departments_id: ''
									};
									that.nowFile = res3.data.image_info;
									that.selectedFile = res3.data.image_info.id;
									that.fileName = res3.data.image_info.name;
									that.$nextTick(() => {
										that.getDepartment(res3.data.departments_id);
									})
								}
							});
					// 	}
					// });
				}
			});
		}else {
			//请求文件类型
			resourcesLeixingList({ page: 1, page_size: 9999, keyword: '' }).then(res => {
				if(res.code == 200) {
					//请求公司列表
					// companyList({ page: 1, page_size: 9999, status: 1, company_name: '', company_userid: '', manage_userid: '' }).then(res2 => {
					// 	if(res2.code == 200) {
							that.resourcesLeixingList = res.data.data;
							that.$nextTick(() => {
								that.getDepartment();
							})
							// that.companyList = res2.data.data;
					// 	}
					// });
				}
			});
		}
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//请求部门列表
		getDepartment(value, val) {
			let that = this;
			that.form.departments_id = '';
			that.departmentsList = [];
			that.$toast.loading({ duration: 0, forbidClick: true });
			departmentsList({ page: 1, page_size: 9999, status: 1, departments_name: '', departments_userid: '' }).then(res2 => {
				that.$toast.clear();
				that.departmentsList = res2.data.data;
				if(val) {
					that.form.departments_id = Number(val);
				}
			});
		},
		handleAvatarSuccess(res, file) {
			let that = this;
			if (!file && !res) return;
			that.selectedFile = res.data.id;
			that.fileName = res.data.name;
			that.$toast.clear();
		},
		beforeAvatarUpload(file) {
			let that = this;
			const maxSize = 10 * 1024 * 1024; // 10MB
			const isLt100M = file.size <= maxSize;
			if(!isLt100M) {
				that.$message.error("Uploaded file size cannot exceed 10MB");
				return false;
			}
			that.$toast.loading({ duration: 0, forbidClick: true });
		},
		handleSubmit() {
			let that = this;
			that.$refs.formRef.validate((valid) => {
				if(!valid) return;
				if(!that.selectedFile) { that.$toast('Please upload file first'); return false; }
				that.$toast.loading({ duration: 0, forbidClick: true });
				let query = {
					id: that.$route.query.id,
					leixing_id: that.form.leixing_id,
					ref: that.form.ref,
					vnumber: that.form.vnumber,
					vname: that.form.vname,
					// company_id: that.form.company_id,
					departments_id: that.form.departments_id,
					vdesc: that.form.vdesc,
					image_id: that.selectedFile,
					operation: 1,
					flow_type: 'resources_update'
				};
				if(that.vid) {
					//编辑
					query.old_vid = that.form.old_vid;
					query.vid = that.vid;
				}else {
					//添加
					query.old_vid = 0;
					query.vid = '';
				}
				// console.log(query);
				resourcesAdd(query).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							this.$router.back();
						}, 800);
					}
				});
			});
		},
		handleCancel() {
			this.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
		//查看文件
		viewFile(value) {
			window.open(value);
		}
	},
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
	.btn_box{
		text-align: center;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
::v-deep .btn span {
  text-decoration: underline;
}

.form-card {
  border-radius: 4px;
}

.tip-bar {
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f8f1e2;
  color: #333;
  border-radius: 4px;
  line-height: 1.5;
  font-size: 14px;
}

.doc-form {
  color: #303133;
}

.full-width {
  width: 100%;
}

.dept-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dept-input {
  flex: 1;
}

.divider {
  height: 1px;
  background: #dcdfe6;
  margin: 24px 0;
}

.upload-doc-wrapper {
  width: 100%;
  margin-bottom: 40px;
  box-sizing: border-box;
}

.upload-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 14px;
  font-weight: 500;
}

.upload-limit {
  color: #666;
  font-weight: 400;
}

.upload-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f7fa;
}

.doc-upload {
  flex-shrink: 0;
}

.select-btn {
  height: 44px;
  border: none;
  border-right: 1px solid #dcdfe6;
  border-radius: 0;
  background: #f5f7fa;
  color: #333;
  padding: 0 20px;
}

.select-btn:hover,
.select-btn:focus {
  background: #eef1f6;
  color: #333;
}

.file-name {
  flex: 1;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  font-size: 15px;
  color: #333;
  background: #f5f7fa;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-name.placeholder {
  color: #999;
}

.footer-actions {
  margin-top: 26px;
  display: flex;
  justify-content: center;
  gap: 14px;
}
</style>

